class ReaderApplicationData {
    serial: string;  // eslint-disable-line lines-between-class-members
    lastProcessList: Date;  // eslint-disable-line lines-between-class-members
    appName: string;  // eslint-disable-line lines-between-class-members
    appVersion: string;  // eslint-disable-line lines-between-class-members
  
    constructor(serial: string, lastProcessList: Date, appName: string, appVersion: string) {
      this.lastProcessList = lastProcessList;
      this.serial = serial;
      this.appName = appName;
      this.appVersion = appVersion;
    };
  };

export {
    ReaderApplicationData  // eslint-disable-line import/prefer-default-export
}